import dgnav from "./dg-nav.vue";
import dgfooter from "./dg-footer.vue";
import dgfinancenav from "./dg-finance-nav.vue";


const components = [
  dgnav,
  dgfinancenav,
  dgfooter,
];

// export default function install(app) {
//   components.forEach(el => {
//     app.component(el.name, el);
//   });
// }

// const dgUI = function(Vue, opts = {}) {
//   if (dgUI.installed) return;
//   components.map(component => {
//     Vue.component(component.name, component);
//   });
// };

const install = function (Vue, opts = {}) {
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  dgfinancenav,
  dgfooter,
  dgnav
};
